import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Rectangle,
} from 'recharts';

import './styles.css';

class IssuedInvoicesOnTerminalChart extends React.Component {
  render() {
    const {
      late,
      onTime,
    } = this.props;

    return (
      <ResponsiveContainer width="100%" height={10}>
        <BarChart
          layout="vertical"
          data={[
            {
              name: 'Invoices', late, onTime,
            },
          ]}
          margin={{
            top: 0, right: 0, left: 0, bottom: 0,
          }}
        >
          <XAxis hide type="number" domain={[0, 'dataMax']} />
          <YAxis hide type="category" dataKey="name" />
          <Bar dataKey="late" stackId="a" fill="#50E3C2" shape={<Rectangle radius={[5, 5, 5, 5]} />} />
          <Bar dataKey="onTime" stackId="a" fill="#21C756" shape={<Rectangle radius={[5, 5, 5, 5]} />} />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default IssuedInvoicesOnTerminalChart;
